import React from "react";
import "./DeshbordBreadcrumb.css";
import { Link } from "react-router-dom";

export default function DeshbordBreadcrumb({ homeLink, homeName, page1 }) {
  return (
    <>
      <div className="pagebreadcrumb">
        <nav className="breadcrumbSDFDF">
          <ul className="breadcrumb-links">
            <li>
              <Link
                to={homeLink ? `${homeLink}` : `/deshboard`}
                className="breadcrumb-box"
              >
                <i
                  className="fa fa-home breadcrumb-icon"
                  aria-hidden="true"
                ></i>
              </Link>
            </li>
            {page1 &&
              page1.map((value, index) => (
                <li key={index}>
                  {value.pagelink ? (
                    <Link to={`/${value.pagelink}`} className="breadcrumb-box">
                      <i
                        className="fa fa-angle-right breadcrumb-icon"
                        aria-hidden="true"
                      ></i>
                      <span className="breadcrumb-text">{value.name}</span>
                    </Link>
                  ) : (
                    <div className="breadcrumb-box">
                      <i
                        className="fa fa-angle-right breadcrumb-icon"
                        aria-hidden="true"
                      ></i>
                      <span className="breadcrumb-text">{value.name}</span>
                    </div>
                  )}
                </li>
              ))}
          </ul>
        </nav>
      </div>
    </>
  );
}
